import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { BcacIconComponent } from './bcac-icon.component';
import { BcacSoundRecordComponent } from './bcac-sound-record/bcac-sound-record.component';
import { BcacLegendToolboxComponent } from './bcac-legend-toolbox/bcac-legend-toolbox.component';
import { BcacSingleSelectIconComponent } from './bcac-single-select-icon/bcac-single-select-icon.component';
import { BcacZoomIconComponent } from './bcac-zoom-icon/bcac-zoom-icon.component';
import { BcacBrushIconComponent } from './bcac-brush-icon/bcac-brush-icon.component';
 

@NgModule({
  declarations: [BcacIconComponent, BcacSoundRecordComponent, BcacLegendToolboxComponent, BcacSingleSelectIconComponent, BcacZoomIconComponent, BcacBrushIconComponent],
  imports: [
    CommonModule, 
    NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule
  ], 
  exports: [
    BcacIconComponent,
    BcacSoundRecordComponent,
    BcacLegendToolboxComponent,
    BcacSingleSelectIconComponent,
    BcacZoomIconComponent,
    BcacBrushIconComponent
  ]
})
export class BcacIconModule { }
